import SEO from "@/components/site/SEO";
import LegalShell from "@/components/site/LegalShell";

export default function AccountDeletion() {
  return (
    <LegalShell
      title="Account Deletion"
      lastUpdated="January 1, 2026"
      pageTestId="account-deletion-page"
      seo={
        <SEO
          title="Account Deletion"
          description="How to request deletion of your OneDial Africa account and personal data, as required by Google Play and Apple App Store policies."
          path="/account-deletion"
        />
      }
    >
      <p>
        This page explains how to request deletion of your <strong>OneDial Africa</strong>{" "}
        account and associated personal data, in accordance with Google Play and Apple
        App Store requirements as well as the UK GDPR.
      </p>

      <h2>1. Who this applies to</h2>
      <p>Any individual who has created an account on the OneDial Africa mobile app or website. OneDial Africa is a trading name of Scitygate Telecom UK Ltd, registered in England &amp; Wales under Company No. 16468736.</p>

      <h2>2. Delete your account in-app</h2>
      <ol>
        <li>Open the OneDial Africa app and sign in.</li>
        <li>Go to <strong>Settings</strong> → <strong>Account</strong> → <strong>Delete Account</strong>.</li>
        <li>Confirm your identity, follow the on-screen prompts and confirm deletion.</li>
      </ol>

      <h2>3. Delete your account by email</h2>
      <p>
        If you cannot access the app, you can request deletion by emailing{" "}
        <a href="mailto:support@onedialafrica.com" className="underline">support@onedialafrica.com</a>{" "}
        from the email address registered to your account, including:
      </p>
      <ul>
        <li>Your full name as registered.</li>
        <li>The phone number associated with your account.</li>
        <li>The country in which you registered.</li>
        <li>The subject line: <strong>“Account Deletion Request”</strong>.</li>
      </ul>
      <p>We may ask additional questions to verify your identity before processing the request.</p>

      <h2>4. What data is deleted</h2>
      <p>Upon successful verification we will delete or anonymise the following:</p>
      <ul>
        <li>Profile data (name, email, phone number, date of birth, country).</li>
        <li>App preferences, contacts and chat content stored on our servers.</li>
        <li>Marketing identifiers and analytics linked to your account.</li>
      </ul>

      <h2>5. What data may be retained</h2>
      <p>Certain data must be retained to meet legal, regulatory, tax, anti-money-laundering and dispute-resolution obligations. This may include:</p>
      <ul>
        <li>Transaction records (calls, top-ups, transfers, bill payments) for the period required by applicable law (typically a minimum of six years in the UK).</li>
        <li>KYC/AML documentation as required by financial-services regulators.</li>
        <li>Security logs necessary to prevent fraud and protect our platform.</li>
      </ul>
      <p>Retained data is held securely, access-controlled and used only for the purposes described above.</p>

      <h2>6. Timeline</h2>
      <p>We will action verified deletion requests within thirty (30) days. We will confirm by email once your account has been deleted.</p>

      <h2>7. Wallet balances and pending transactions</h2>
      <p>Before deletion, please withdraw any remaining wallet balance and ensure no transactions are pending. We will contact you if there are funds or transactions that must be resolved before we can complete deletion.</p>

      <h2>8. Reactivation</h2>
      <p>Once your account is deleted it cannot be restored. You may create a new account at any time using the same or different credentials.</p>

      <h2>9. Contact</h2>
      <p>
        Scitygate Telecom UK Ltd<br />
        2nd Floor, Halifax House, 93–101 Bridge Street, Manchester M3 2GX, United Kingdom<br />
        Registered in England &amp; Wales · Company No. 16468736<br />
        Telephone: 0161 989 4842<br />
        Email: <a href="mailto:support@onedialafrica.com" className="underline">support@onedialafrica.com</a>
      </p>
    </LegalShell>
  );
}
